import { Stack, type SxProps, type Theme } from '@mui/material';
import classnames from 'classnames';

import { useScrollable } from './useScrollable';

export const ScrollableContent = ({
  children,
  className,
  sx,
  'data-testid': dataTestId,
}: React.PropsWithChildren<{
  className?: string;
  sx?: SxProps<Theme>;
  'data-testid'?: string;
}>) => {
  const { isScrolledVertically, setIsScrolledVertically } = useScrollable();

  return (
    <Stack
      className={classnames('overflow-auto', className)}
      data-testid={dataTestId}
      onScroll={(event) => {
        const target = event.target as HTMLDivElement;
        if (typeof target.scrollTop === 'number') {
          const isScrolled = target.scrollTop > 0;
          if (isScrolled !== isScrolledVertically) {
            setIsScrolledVertically(isScrolled);
          }
        }
      }}
      sx={[
        {
          flexGrow: 1,
        },
        ...(Array.isArray(sx) ? sx : [sx ?? false]),
      ]}
    >
      {children}
    </Stack>
  );
};
